import { render, staticRenderFns } from "./ultrasonicGroupInfo.vue?vue&type=template&id=9822f940&scoped=true&"
import script from "./ultrasonicGroupInfo.vue?vue&type=script&lang=js&"
export * from "./ultrasonicGroupInfo.vue?vue&type=script&lang=js&"
import style0 from "./ultrasonicGroupInfo.vue?vue&type=style&index=0&id=9822f940&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9822f940",
  null
  
)

export default component.exports